<ngx-barcode6
    *ngIf="barcodeValue"
    [bc-value]="barcodeValue"
    [bc-display-value]="displayValue"
    bc-text-align="center"
    [bc-height]="60"
></ngx-barcode6>
